import React from "react";

const AdvancedSearchSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M13.125 13.125L11.0508 11.0508M11.0508 11.0508C11.312 10.7897 11.5192 10.4796 11.6605 10.1384C11.8019 9.79716 11.8746 9.43143 11.8746 9.06208C11.8746 8.69274 11.8019 8.32701 11.6605 7.98578C11.5192 7.64455 11.312 7.3345 11.0508 7.07333C10.7897 6.81217 10.4796 6.605 10.1384 6.46366C9.79716 6.32231 9.43143 6.24957 9.06208 6.24957C8.69274 6.24957 8.32701 6.32231 7.98578 6.46366C7.64455 6.605 7.3345 6.81217 7.07333 7.07333C6.54577 7.60089 6.24939 8.31642 6.24939 9.0625C6.24939 9.80858 6.54577 10.5241 7.07333 11.0517C7.60089 11.5792 8.31642 11.8756 9.0625 11.8756C9.80858 11.8756 10.5241 11.5792 11.0517 11.0517L11.0508 11.0508ZM17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z"
      stroke="#757373"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default AdvancedSearchSvg;
